import { Builder } from '@builder.io/sdk';
import { HubFeaturedArticles, HUB_FEATURED_ARTICLES_NAME } from './HubFeaturedArticles';
import { BuilderInputOptions } from '@/types/builder';

const HubFeaturedArticlesConfig = {
  name: HUB_FEATURED_ARTICLES_NAME,
  friendlyName: 'Hub Featured Articles',
  description:
    'A hero article card with excerpt and "Read more" button, plus up to 3 overlay-style sub-cards. Used at the top of hub/category pages.',
  inputs: [
    {
      name: 'title',
      type: 'richText',
      friendlyName: 'Heading',
      defaultValue: 'Featured <span style="color: #FE5000;">[HUB NAME]</span> articles for',
      helperText:
        'The section heading. Use rich text to colour the hub name orange — select the text and set its colour to #FE5000. The current month/year is appended automatically when "Show current month" is on.',
    },
    {
      name: 'showDate',
      type: 'boolean',
      friendlyName: 'Show current month',
      defaultValue: true,
      helperText: 'When on, the current month and year (e.g. "March 2026") are automatically appended to the heading.',
    },
    {
      name: 'featuredLabel',
      type: 'string',
      friendlyName: 'Featured Badge Label',
      defaultValue: 'Featured',
      helperText: 'Text shown on the orange badge overlaying the hero image (e.g. "Featured", "Editor\'s Pick").',
    },
    {
      name: 'featuredExcerpt',
      type: 'longText',
      friendlyName: 'Featured Article Excerpt',
      helperText:
        'A short summary shown below the featured article title. Keep it to 1–2 sentences to avoid the card getting too tall.',
    },
    {
      name: 'autoSelectLatest',
      type: 'boolean',
      friendlyName: 'Auto-select latest articles',
      helperText:
        'When on, automatically shows the most recent articles (first = featured hero, rest = sub-cards). Turn off to hand-pick articles.',
      defaultValue: true,
    },
    {
      name: 'limit',
      type: 'number',
      friendlyName: 'Number of articles',
      helperText: 'How many articles to show (1 featured + the rest as sub-cards). Default: 4.',
      defaultValue: 4,
      min: 1,
      max: 10,
      showIf: (options: BuilderInputOptions) => options?.get('autoSelectLatest') !== false,
    },
    {
      name: 'articles',
      type: 'list',
      friendlyName: 'Articles',
      helperText: 'Pick articles manually. The first one becomes the hero card; the rest appear as sub-cards.',
      showIf: (options: BuilderInputOptions) => options?.get('autoSelectLatest') === false,
      subFields: [
        {
          name: 'article',
          type: 'reference',
          model: 'article',
        },
      ],
    },
  ],
};

Builder.registerComponent(HubFeaturedArticles, HubFeaturedArticlesConfig);
